









import { Vue, Component, Prop, Ref } from 'vue-property-decorator';
import { v4 as uuidv4 } from 'uuid';
import APP_CONST from '@/constants/AppConst';

@Component
export default class Spinner extends Vue {
  @Prop({ type: Number, default: 1 }) spinnerRatio!: number;
  @Prop({ type: String, default: APP_CONST.STYLE.COLOR.PRIMARY_700 }) spinnerColor!: string;
  @Prop({ type: Number, default: null }) spinnerThickness!: number;
  @Ref('svgContainer') svgContainer!: HTMLElement;

  public readonly uuid: string = uuidv4();

  get formattedSpinnerRatio(): string {
    const formattedSpinnerRatio = `ratio: ${this.spinnerRatio.toString()}`;
    return formattedSpinnerRatio;
  }

  public mounted() {
    this.delayHackForUiKitSpinnerRendering(() => {
      this.setSpinnerThickness();
    });
  }

  private delayHackForUiKitSpinnerRendering(callback: Function) {
    setTimeout(callback);
  }

  private setSpinnerThickness() {
    if (this.svgContainer && this.svgContainer instanceof HTMLElement) {
      const innerCircle = this.svgContainer.querySelector('circle');
      if (innerCircle && this.spinnerThickness) {
        innerCircle.style.strokeWidth = `${this.spinnerThickness.toString()}px`;
      }
    }
  }
}
